<script setup lang="ts">
import {useAuth} from "~/composible/useAuth";

const appConfig = useAppConfig();
const route = useRoute();
const path = computed(() => route.path);

const { isAuthModalShow, closeAuthModal } = useAuth();

const isReady = ref(false);
const year = new Date().getFullYear();

const scrollTop = () => {
  if (route.path === '/') {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }
}

onMounted(() => {
  isReady.value = true;
})
</script>

<template>
  <footer class="bg-white py-8 max-md:py-4 border-t border-[#EFF2F5] dark:border-zinc-700 dark:bg-zinc-800">
    <div class="container">
      <div class="flex justify-between items-center py-4 border-b border-[#EFF2F5] dark:border-zinc-700">
        <nuxt-link to="/" @click="scrollTop" aria-label="FictionMe Logo">
          <svg class="!text-gray-950 dark:!text-white" width="117" height="32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.176 24.381V14.043C15.176 8.496 10.679 4 5.133 4v10.34c0 5.547 4.496 10.041 10.043 10.041Zm2.292 4.753v-7.142a9.016 9.016 0 0 1 9.015-9.016v7.142a9.016 9.016 0 0 1-9.015 9.016ZM21.665 4.98a3.409 3.409 0 1 1-1.578 6.633 3.409 3.409 0 0 1 1.578-6.633Z" fill="#8019F8"/><path d="M41 22.192v-12.6h7.272v1.854H43.07v3.996h5.202v1.854H43.07v4.896H41ZM52.231 12.184c-.276.276-.624.414-1.044.414-.42 0-.768-.138-1.044-.414a1.454 1.454 0 0 1-.414-1.044c0-.408.138-.75.414-1.026a1.385 1.385 0 0 1 1.044-.432c.42 0 .768.144 1.044.432.276.276.414.618.414 1.026 0 .408-.138.756-.414 1.044Zm-2.034 10.008v-8.388h1.962v8.388h-1.962ZM57.986 22.408c-1.284 0-2.304-.402-3.06-1.206-.744-.816-1.116-1.884-1.116-3.204 0-1.32.372-2.382 1.116-3.186.756-.816 1.776-1.224 3.06-1.224 1.152 0 2.076.294 2.772.882.708.576 1.11 1.35 1.206 2.322h-1.962c-.216-.972-.888-1.458-2.016-1.458-.696 0-1.242.234-1.638.702-.384.456-.576 1.11-.576 1.962 0 .852.192 1.512.576 1.98.396.456.942.684 1.638.684 1.116 0 1.788-.456 2.016-1.368h1.962c-.096.948-.498 1.704-1.206 2.268-.696.564-1.62.846-2.772.846ZM67.332 20.536c.396 0 .726-.024.99-.072v1.728a8.517 8.517 0 0 1-1.458.108c-.324 0-.606-.024-.846-.072a3.318 3.318 0 0 1-.846-.324c-.324-.18-.576-.486-.756-.918-.18-.432-.27-.978-.27-1.638v-3.906h-1.422v-1.638h1.422v-2.538h1.962v2.538h1.926v1.638h-1.926v3.456c0 .672.096 1.116.288 1.332.192.204.504.306.936.306ZM71.92 12.184c-.276.276-.624.414-1.044.414-.42 0-.769-.138-1.044-.414a1.454 1.454 0 0 1-.414-1.044c0-.408.137-.75.413-1.026a1.385 1.385 0 0 1 1.044-.432c.42 0 .769.144 1.044.432.276.276.415.618.415 1.026 0 .408-.139.756-.415 1.044Zm-2.035 10.008v-8.388h1.962v8.388h-1.962ZM81.148 21.166c-.792.828-1.866 1.242-3.222 1.242-1.356 0-2.436-.414-3.24-1.242-.792-.84-1.188-1.896-1.188-3.168 0-1.272.396-2.322 1.188-3.15.804-.84 1.884-1.26 3.24-1.26 1.356 0 2.43.42 3.222 1.26.804.828 1.206 1.878 1.206 3.15s-.402 2.328-1.206 3.168Zm-5.04-1.242c.444.492 1.05.738 1.818.738s1.368-.246 1.8-.738c.444-.492.666-1.134.666-1.926s-.222-1.434-.666-1.926c-.432-.492-1.032-.738-1.8-.738s-1.374.246-1.818.738c-.432.492-.648 1.134-.648 1.926s.216 1.434.648 1.926ZM83.995 22.192v-8.388h1.962v1.17c.54-.924 1.452-1.386 2.736-1.386 2.04 0 3.06 1.11 3.06 3.33v5.274h-1.962v-4.374c0-.912-.138-1.566-.414-1.962-.276-.396-.75-.594-1.422-.594-.636 0-1.128.204-1.476.612-.348.396-.522.966-.522 1.71v4.608h-1.962ZM94.04 22.192v-12.6h1.98l4.033 9.648 4.014-9.648h1.98v12.6h-1.98v-8.334l-3.24 8.334h-1.566l-3.24-8.424v8.424h-1.98ZM116.02 17.566c0 .216-.018.576-.054 1.08h-6.228c.024.66.24 1.17.648 1.53.408.348.972.522 1.692.522.924 0 1.548-.318 1.872-.954h1.98c-.132.78-.558 1.422-1.278 1.926-.708.492-1.566.738-2.574.738-1.32 0-2.364-.396-3.132-1.188-.768-.792-1.152-1.866-1.152-3.222 0-1.344.378-2.412 1.134-3.204.768-.804 1.794-1.206 3.078-1.206 1.2 0 2.166.372 2.898 1.116.744.732 1.116 1.686 1.116 2.862Zm-6.282-.414h4.356c-.012-.648-.204-1.146-.576-1.494-.36-.348-.876-.522-1.548-.522-.684 0-1.224.186-1.62.558-.396.372-.6.858-.612 1.458Z" fill="currentColor"/></svg>
        </nuxt-link>
        <ul class="flex max-md:hidden">
          <li class="p-4">
            <nuxt-link to="/" @click="scrollTop">Home</nuxt-link>
          </li>
          <li class="p-4">
            <nuxt-link to="/genres/all-novels">Novels</nuxt-link>
          </li>
          <li class="p-4">
            <nuxt-link to="/stories">Stories</nuxt-link>
          </li>
          <li class="p-4">
            <nuxt-link  :to="appConfig.authorCabinetUrl" target="_blank">Become a writer</nuxt-link>
          </li>
          <li class="p-4">
            <nuxt-link to="/search">Search</nuxt-link>
          </li>
        </ul>
      </div>
      <div class="flex my-8 justify-between max-md:flex-col">
        <div class="max-md:mb-8">
          <div class="pb-2">Download the app</div>
          <div class="flex gap-20">
            <ul class="flex gap-3 justify-start text-[32px]">
              <li class="">
                <a :href="appConfig.store.google" target="_blank" rel="nofollow" aria-label="play store">
                  <Icon name="fm:google" />
                </a>
              </li>
              <li>
                <a :href="appConfig.store.apple" target="_blank" rel="nofollow" aria-label="app store">
                  <Icon name="fm:apple" />
                </a>
              </li>
            </ul>

            <div class="flex gap-4">
              <nuxt-img
                  alt="Visa Logo"
                  src="/img/visa_logo.png"
                  height="32"
                  loading="lazy"
              />
              <nuxt-img
                  alt="Mastercard Logo"
                  src="/img/mastercard_logo.webp"
                  height="32"
                  loading="lazy"
              />
            </div>
          </div>
        </div>
        <div>
          <div class="pb-2">Follow us</div>
          <ul class="flex gap-3 justify-start text-[32px]">
            <li v-if="appConfig.socials.facebook">
              <a :href="appConfig.socials.facebook" target="_blank" rel="nofollow" aria-label="facebook">
                <icon name="fm:socials-facebook" />
              </a>
            </li>
            <li v-if="appConfig.socials.instagram">
              <a :href="appConfig.socials.instagram" target="_blank" rel="nofollow" aria-label="instagram">
                <icon name="fm:socials-instagram" />
              </a>
            </li>
            <li v-if="appConfig.socials.tiktok">
              <a :href="appConfig.socials.tiktok" target="_blank" rel="nofollow" aria-label="tiktok">
                <icon name="fm:socials-tiktok" />
              </a>
            </li>
            <li v-if="appConfig.socials.youtube">
              <a :href="appConfig.socials.youtube" target="_blank" rel="nofollow" aria-label="youtube">
                <icon name="fm:socials-youtube" />
              </a>
            </li>
            <li v-if="appConfig.socials.twitter">
              <a :href="appConfig.socials.twitter" target="_blank" rel="nofollow" aria-label="twitter">
                <icon name="fm:socials-twitter-x" />
              </a>
            </li>
            <li v-if="appConfig.socials.linkedin">
              <a :href="appConfig.socials.linkedin" target="_blank" rel="nofollow" aria-label="linkedin">
                <icon name="fm:socials-linkedin" />
              </a>
            </li>
            <li v-if="appConfig.socials.reddit">
              <a :href="appConfig.socials.reddit" target="_blank" rel="nofollow" aria-label="reddit">
                <icon name="fm:socials-reddit" />
              </a>
            </li>
            <li v-if="appConfig.socials.quora">
              <a :href="appConfig.socials.quora" target="_blank" rel="nofollow" aria-label="quora">
                <icon name="fm:socials-quora" />
              </a>
            </li>
            <li v-if="appConfig.socials.medium">
              <a :href="appConfig.socials.medium" target="_blank" rel="nofollow" aria-label="medium">
                <icon name="fm:socials-medium" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="flex items-center justify-between py-8 border-t border-[#EFF2F5] dark:border-zinc-700 max-lg:flex-col-reverse max-lg:items-start max-lg:gap-5">
        <div>
          {{ year }} © <i>All Rights Reserved. Bonimor Limited.</i>
          <span class="max-xl:block">Payments & transactions partner: Nordgate Atlantic (Portugal).</span>
          <span class="block">Richardou Leontokardou, 11, ANNEX COURT, Flat/Office 101 4046, Limassol, Cyprus</span>
        </div>
        <ul class="flex gap-5 max-md:grid max-md:grid-cols-2 max-md:gap-3">
          <li>
            <a href="/public/web-terms-of-use.html">Terms of use</a>
          </li>
          <li>
            <a href="/public/dmca-notice.html">DMCA</a>
          </li>
          <li>
            <a href="/public/web-privacy-policy.html">Privacy policy</a>
          </li>
          <li>
            <a href="/public/refund-policy.html">Refund policy</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>

  <cookies-banner />
  <popup :is-visible="isAuthModalShow" @close="closeAuthModal" additional-classes="p-6">
    <lazy-auth-flow />
  </popup>

  <lazy-styles-loader v-if="isReady" />
</template>

<style scoped>

</style>